import { graphql } from 'gatsby';
import * as React from 'react';
import Carousel from '../components/carousel.component';
import Layout from '../components/layout.component';

function AboutPage(props) {
  return (
    <Layout>
      <Carousel indexPage={props.data.dataJson.indexPage} coverText={`About`}></Carousel>
    </Layout>
  );
}

export const query = graphql`
  query AboutQuery {
    dataJson {
      indexPage {
        images
      }
      churchName
    }
  }
`;

export default AboutPage;
